<template>
    <div class="flex flex-col gap-4 text-white">
        <div class="flex items-center gap-x-2">
            <Icon name="phone" class="text-sm" /><a
                href="tel:1-866-516-7247"
                class="text-inherit"
                >866-516-7247</a
            >
        </div>
        <div class="flex items-center gap-x-2">
            <Icon name="envelope-solid" class="text-sm" /><a
                href="mailto:info@roastar.com"
                class="text-inherit"
                >info@roastar.com</a
            >
        </div>
        <div class="flex items-center gap-x-2">
            <Icon name="comment-solid" class="text-sm" /><button
                class="text-inherit underline hover:no-underline"
                @click="chat"
            >
                chat with us
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { openZendeskChat } from '~/utils/zendeskChat';

const chat = () => {
    openZendeskChat('Contact Links');
};
</script>
